import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const COPY = {
  en: { plan: "Plan", free: "Free", used: "questions used", grant: "Give unlimited access", revoke: "Remove tester access", granted: "Unlimited access given", revoked: "Tester access removed" },
  fr: { plan: "Offre", free: "Gratuit", used: "questions utilisées", grant: "Donner un accès illimité", revoke: "Retirer l'accès testeur", granted: "Accès illimité accordé", revoked: "Accès testeur retiré" },
  ar: { plan: "الخطة", free: "مجانية", used: "أسئلة مستخدمة", grant: "منح وصول غير محدود", revoke: "إزالة وصول المختبِر", granted: "تم منح وصول غير محدود", revoked: "تمت إزالة وصول المختبِر" },
};

export const AdminUserRow = ({ u, lang, onUpdated }) => {
  const c = COPY[lang] || COPY.en;
  const [busy, setBusy] = useState(false);
  const sub = u.subscription || {};
  const isTester = sub.tier_id === "tester";
  const isAdmin = u.role === "admin";
  const isPaid = sub.tier_id && !isTester && sub.status === "active";

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/users/${u.user_id}/access`, { unlimited: !isTester });
      onUpdated(data);
      toast.success(isTester ? c.revoked : c.granted);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="p-5 flex flex-col md:flex-row md:items-center gap-4 justify-between" data-testid={`admin-user-${u.email}`}>
      <div className="min-w-0">
        <div className="font-medium text-[#0A1128] truncate">{u.name || u.email}</div>
        <div className="text-sm text-[#495057] truncate">{u.email}{u.company ? ` · ${u.company}` : ""}</div>
        <div className="mt-1 text-xs text-[#868E96]" data-testid={`admin-user-plan-${u.email}`}>
          {c.plan}: <span className={isTester ? "text-[#C65D47] font-medium" : ""}>{sub.tier_name || c.free}</span>
          {" · "}{u.question_used_this_period || 0} {c.used}
        </div>
      </div>
      {!isAdmin && !isPaid && (
        <button onClick={toggle} disabled={busy} data-testid={`admin-toggle-access-${u.email}`}
          className={`shrink-0 px-4 py-2 text-sm border transition-colors disabled:opacity-60 ${isTester ? "border-[#0A1128] text-[#0A1128] hover:bg-[#F8F9FA]" : "bg-[#0A1128] text-white border-[#0A1128] hover:bg-[#1C2538]"}`}>
          {isTester ? c.revoke : c.grant}
        </button>
      )}
    </div>
  );
};
